export default `<p style="text-align:center;line-height:24px;background:white">
    <strong><span style="font-size:21px color:black;background:white">易才宏业保险经纪隐私政策</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" background:white">&nbsp;</span>
</p>
<p style="text-align:center;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">版本更新及生效时间：2024年8月30日</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;text-indent:28px;line-height:24px;background:white">
    <span style=" color:black;background:white">尊敬的用户您好，感谢您使用易才宏业保险经纪的产品及服务！</span>
</p>
<p style="text-align:left;text-indent:28px;line-height:24px;background:white">
    <span style=" color:black;background:white">为了更好地提供服务，易才宏业保险经纪有限公司（以下简称“易才”或“我们”）按照合法、合规、合理、安全、保密的原则，依据信息安全及保险相关的法律法规要求，合理收集、保存、使用和共享您的个人信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。请您在使用我们所提供的产品或服务前，务必仔细阅读本<strong>《易才宏业保险经纪隐私政策》（以下简称“本政策”）</strong>，尤其是加黑加粗部分。在您开始使用我们所提供的产品或服务后，您仍可通过“首页-底部”或 “企业注册“、”用户登陆时“-查询隐私政策申明的内容。</span>
</p>
<p style="text-align:left;text-indent:28px;line-height:24px;background:white">
    <span style=" color:black;background:white">本政策适用于易才宏业保险经纪旗下所有外报平台（含网站、APP、微信公众号、微信小程序、H5页面）所有产品和服务。</span>
</p>
<p style="text-align:left;text-indent:28px;line-height:24px;background:white">
    <span style=" color:black;background:white">如果您有任何个人信息的疑问、意见、建议或投诉举报，请通过以下联系人及联系方式与我们联系：</span>
</p>
<p style="text-align:left;text-indent:28px;line-height:24px;background:white">
    <span style=" color:black;background:white">用户服务联系人：曹永萌</span>
</p>
<p style="text-align:left;text-indent:28px;line-height:24px;background:white">
    <span style=" color:black;background:white">电子邮箱：ycbxjj@chinatalentgroup.com</span>
</p>
<p style="text-align:left;text-indent:28px;line-height:24px;background:white">
    <span style=" color:black;background:white">专线：4006-234-345</span>
</p>
<p style="text-align:left;text-indent:28px;line-height:24px;background:white">
    <span style=" color:black;background:white">注册地址：天津市河西区黑牛城道与洞庭路交口东南侧五福大厦-1-1407、-1-1408</span>
</p>
<table cellspacing="0" cellpadding="0" style="margin: 0 auto">
    <tbody>
        <tr class="firstRow">
            <td width="568" valign="top" style="border: 1px solid windowtext; padding: 0px 7px;">
                <p style="text-align:center;line-height:24px;background:white">
                    <strong><span style=" color:black;background:   white">本政策将帮助您了解以下内容</span></strong>
                </p>
            </td>
        </tr>
        <tr>
            <td width="568" valign="top" style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;">
                <p style="text-align:left;text-indent:28px;line-height:24px;background:white">
                    <span style=" color:black;background:white">1.</span><span style=" color:black;background:white">我们收集哪些您的个人信息</span>
                </p>
            </td>
        </tr>
        <tr>
            <td width="568" valign="top" style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;">
                <p style="text-align:left;text-indent:28px;line-height:24px;background:white">
                    <span style=" color:black;background:white">2.</span><span style=" color:black;background:white">我们如何使用您的个人信息</span>
                </p>
            </td>
        </tr>
        <tr>
            <td width="568" valign="top" style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;">
                <p style="text-align:left;text-indent:28px;line-height:24px;background:white">
                    <span style=" color:black;background:white">3.</span><span style=" color:black;background:white">我们如何共享、转让、公开披露您的个人信息</span>
                </p>
            </td>
        </tr>
        <tr>
            <td width="568" valign="top" style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;">
                <p style="text-align:left;text-indent:28px;line-height:24px;background:white">
                    <span style=" color:black;background:white">4.</span><span style=" color:black;background:white">我们如何保存和保护您的个人信息</span>
                </p>
            </td>
        </tr>
        <tr>
            <td width="568" valign="top" style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;">
                <p style="text-align:left;text-indent:28px;line-height:24px;background:white">
                    <span style=" color:black;background:white">5.</span><span style=" color:black;background:white">您的权利</span>
                </p>
            </td>
        </tr>
        <tr>
            <td width="568" valign="top" style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;">
                <p style="text-align:left;text-indent:28px;line-height:24px;background:white">
                    <span style=" color:black;background:white">6.</span><span style=" color:black;background:white">我们如何处理未成年人的个人信息</span>
                </p>
            </td>
        </tr>
        <tr>
            <td width="568" valign="top" style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;">
                <p style="text-align:left;text-indent:28px;line-height:24px;background:white">
                    <span style=" color:black;background:white">7.</span><span style=" color:black;background:white">本政策如何更新</span>
                </p>
            </td>
        </tr>
        <tr>
            <td width="568" valign="top" style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;">
                <p style="text-align:left;text-indent:28px;line-height:24px;background:white">
                    <span style=" color:black;background:white">8.</span><span style=" color:black;background:white">如何联系我们</span>
                </p>
            </td>
        </tr>
    </tbody>
</table>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;text-indent:28px;line-height:24px;background:white">
    <span style=" color:black;background:white">我们致力于提供良好的客户服务，回馈您对我们的信任，我们承诺将恪守法律法规及银保监会下发的有关客户个人信息安全的各项规定，尽全力保证您的个人信息安全同时确保各项信息合理使用。同时，我们郑重承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</span>
</p>
<p style="text-align:left;text-indent:28px;line-height:24px;background:white">
    <span style=" color:black;background:white">在您使用易才保险经纪产品、服务过程中，基于您选择使用不同的业务功能，需要向我们提供或允许我们收集的相关信息包括（请<strong>关注下列各项加黑加粗项，该部分将提示您我们收集您的信息的目的、方式及范围</strong>）：</span>
</p>
<p style="margin-left:0;text-align:left;text-indent:0;line-height:24px;background:white">
    <span style=" ">1.1 </span><span style=" color:black;background:white">基于保险产品选购、投保、理赔、保全基本功能需要收集的相关信息</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" background:white">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）当您通过易才保险经纪平台查看选购我们的产品或接受我们的服务，并投保具体保险产品时，我们可能需要获得您的如下信息：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">注册信息：手机号、邮箱号。</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">&nbsp;</span><strong><span style=" color:black;background:white">如果您拒绝提供这些信息，您可能无法正常使用我们的注册账户服务。</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">投保信息：</span></strong><span style=" color:black;background:white">投保人和被保险人的姓名、证件类型 投保人和被保险人的姓名、证件类型 （含身份证、护照、出生证、驾照、港澳通行证、军官证、台胞证、警官证、港澳台回乡证、组织机构代码证、营业执照、税务登记号、三证合一、统一信用代码证、其他单位证件、 户口本、中国护照、外国护照、港澳居民居住证、台湾居民居住证、外国人永久居留身份证、港澳居民来往内地通行证、台湾居民来往大陆通行证、港澳回乡证、结婚证、港澳台居民居住证、士兵证）、 证件号码、 证件有效期、出生日期、身高、体重、职业、性别、民族、国籍、地址、地址邮编、婚姻状况、教育工作信息、健康生理信息、年收入、工作单位名称、人脸信息、投保人与被保险人、受益人之间的关系；受益人的姓名、证件类型 （含身份证、护照、出生证、驾照、港澳通行证、军官证、台胞证、警官证、港澳台回乡证、组织机构代码证、营业执照、税务登记号、 三证合一、统一信用代码证、其他单位证件、户口本、中国护照、外国护照、港澳居民居住证、台湾居民居住证、外国人永久居留身份证、港澳居民来往内地通行证、台湾居民来往大陆通行证、港澳回乡证、结婚证、港澳台居民居住证、士兵证） 、证件号码、证件有效期、出生日期、性别、联系方式，拼音/英文名以及保险订单信息及投保所需的必要信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">如果您拒绝提供这些信息，我们将无法为您提供相关服务以完成投保手续。</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">电话录音、视频录像、在线沟通记录及投保轨迹：</span></strong><span style=" color:black;background:white">根据法律法规及监管规定，您在投保时，我们将对投保过程以现场同步录音录像的方式予以记录；与您致电过程、您在线联系我们从业人员/客服人员、或者您通过移动设备或电脑访问浏览我们平台时，我们将会收集并记录您的电话录音、在线沟通记录及投保轨迹记录。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">如果您拒绝收集这些信息，我们将无法为您提供相关服务以完成投保手续。</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">支付信息：</span></strong><span style=" color:black;background:white">第三方支付信息、银行账户信息、开户银行以及其它支付和财务信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">如果您拒绝收集这些信息，我们将无法为您提供相关服务以完成投保手续。</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" background:white">&nbsp;</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">保单信息</span></strong><span style=" color:black;background:white">：投保地区、保障期限、保额、保费、缴费类型、缴费年限以及其他保单信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">如果您拒绝提供这些信息，我们将无法为您提供相关服务以完成投保手续。</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">客户尽职调查：</span></strong><span style=" color:black;background:white">根据法律法规及监管规定，您在指定被保人、法定继承人以外的受益人时，我们需要收集您指定受益人的身份证、户口本、出生证或其他身份证明文件（含护照、驾照、港澳通行证、军官证、台胞证、警官证、港澳台回乡证、组织机构代码证、营业执照、税务登记号、三证合一、统一信用代码证、其他单位证件、中国护照、外国护照、港澳居民居住证、台湾居民居住证、外国人永久居留身份证、港澳居民来往内地通行证、台湾居民来往大陆通行证、港澳回乡证、结婚证、港澳台居民居住证、士兵证），并留存复印件或影像件。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">如果您拒绝提供这些信息，我们将无法为您提供相关服务以完成投保手续。</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）当您通过我们的平台申请保险合同保全时，我们可能收集您申请保全时所需要的相关信息，包括：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">保单信息、险种信息、联系方式、被保险人姓名、被保险人身份证号码、位置信息、保全申请事由信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">&nbsp;</span></strong><strong><span style=" color:black;background:white">如果您拒绝提供这些信息，我们将无法为您提供保险合同保全的相关服务。</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）当您通过我们的平台申请使用投保、理赔、保全、保单查询功能时，您同意授权我们，收集您合法留存在保险公司的投保、理赔、保全、以及保单信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">1.2 </span><span style=" color:black;background:white">为了账户安全需要收集的信息</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">为了保障您的账号安全、交易安全、系统运行安全，满足法律法规和我们协议规则的相关要求，以及不断地改进我们的产品,在您使用我们的产品和服务时，我们需要收集相关的日志信息与设备信息。 日志信息包括IP地址、访问的浏览器信息、点击和浏览我们产品和服务功能或页面的URL地址及其使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">1.3</span><span style=" color:black;background:white">通过第三方主体或使用第三方服务收集与投保、理赔及风险控制的信息</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）在向您提供投保或其他保险服务过程中， 基于个人保险实名制的要求，我们可能会向第三方主体申请核验您的身份信息的真实性。因此，您授权我们，除法律另有规定之外，收集您合法留存在与我们合作的保险公司、监管机构、司法机关、征信机关、电信运营商或其他机构的个人信息，用于核验您是否具备投保资格。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）为防范保险欺诈行为，我们还可能向行政机关、司法机关、征信机构、医疗机构以及其他合法了解掌握相关信息的自然人和法人处，收集或查询相关信息。因此， 您授权我们向上述机构收集或查询您的身份、财产、健康状况相关信息，以核验是否存在保险欺诈行为。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">1.4</span><span style=" color:black;background:white">使用Cookie和同类技术收集的信息</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。Cookie主要的功能是便于您使用网站产品和服务，以及帮助网站统计独立访客数量。运用Cookie技术，我们能够为您提供更加周到的个性化服务，并允许您设定您特定的服务选项。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）当您使用易才保险经纪的产品和服务时，会向您的设备发送Cookie。当您与我们提供给合作伙伴的服务（广告和/或推广服务，以及可能显示在其他网站上的由易才保险经纪提供的服务功能）进行交互时，您必须允许我们将Cookie（或者其他匿名标识符）发送给易才保险经纪的服务器。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则无法登录或使用依赖于Cookie的易才保险经纪提供的服务或功能。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（4）您可以通过更改您的浏览器设置限制易才保险经纪公司对Cookie的使用。以IE浏览器为例，您可以在IE浏览器右上方的下拉菜单的“Internet选项”的“隐私选项卡”中，通过“设置—高级”，选择阻止我们访问您的Cookie。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">1.5.1</span><span style=" color:black;background:white">安卓权限：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）读取SD卡中的内容（读取存储空间/照片权限）android.permission.READ_EXTERNAL_STORAGE 权限功能说明：提供读取手机储存空间内数据的功能</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">使用场景与目的：允许App读取储存中的图片、文件内容，主要用于上传头像、图片、文件功能</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）写入/删除SD卡中的内容（写入/删除/存储空间/照片权限）android.permission.WRITE_EXTERNAL_STORAGE 权限功能说明：提供写入外部存储功能</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">使用场景与目的：允许App下载/保存/缓存/修改/删除图片、文件信息</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）读取手机状态和身份（电话权限、设备权限）android.permission.READ_PHONE_STATE 权限功能说明：提供读取手机设备标识信息，请你放心该权限无法监听、获取您的任何通话内容与信息</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">使用场景与目的：读取设备通话状态和识别码，识别设备ID，保障运营商网络能正常使用账户登录和安全保障</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（4）拍摄照片和视频 android.permission.CAMERA 权限功能说明：使用拍摄照片和视频使用场景与目的：用于上传头像、投保认证、核保、保全、人脸识别功能</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（5）录制和播放音频 android.permission.RECORD_AUDIO 权限功能说明：使用麦克风录制音频</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">使用场景与目的：用于视频录制</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">1.5.2 IOS</span><span style=" color:black;background:white">权限：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）使用相机权限 NSCameraUsageDescription 权限功能说明：APP内使用拍照功能</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">使用场景与目的：易才保险经纪App需要您的同意打开相机，以识别保单、上传图片，请点击确定。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）读取相册照片权限 NSPhotoLibraryUsageDescription、NSPhotoLibraryAddUsageDescription 权限功能说明：APP内使用三方库选择照片</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">使用场景与目的：易才保险经纪App需要您的同意向相册添加图片，以识别保单、上传图片，请点击确定。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）追踪权限 NSUserTrackingUsageDescription 权限功能说明：读取IDFA</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">使用场景与目的：该权限仅用于提升页面浏览体验，未经您的许可，我们不会获取您在其它站点的隐私信息，也不会将您的信息共享给其它站点。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（4）定位权限 NSLocationWhenInUseUsageDescription 权限功能说明：获取用户当前位置</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">使用场景与目的：易才保险经纪需要获取您的位置信息，向您推荐所在城市的可支持的投保服务。拒绝或取消授权不影响使用其他服务。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（5）使用麦克风权限 NSMicrophoneUsageDescription 权限功能说明：允许APP使用麦克风进行录音</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">使用场景与目的：视频录制的必要权限，在投保、保全、在线回访业务中，允许用户录制视频类材料并上传以及支持部分人脸认证功能。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">1.6</span><span style=" color:black;background:white">提供技术服务的第三方SDK提供商收集的信息</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">为保证易才保险经纪平台相关功能的实现与应用稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关目的。这些第三方SDK提供商会主动收集您的信息以提供相应的服务。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">1.7 </span><span style=" color:black;background:white">征得同意的例外</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">1.</span></strong><strong><span style=" color:black;background:white">【我们收集哪些您的个人信息】</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">请您知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）与国家安全、国防安全有关的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）与公共安全、公共卫生、重大公共利益有关的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）与犯罪侦查、起诉、审判和判决执行等有关的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（5）所收集的个人信息是个人信息主体自行向社会公众公开的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（6）从合法公开披露的信息中收集的您的个人信息的情形，合法的新闻报道、政府信息公开等渠道；但是您明确拒绝或者处理该信息侵害您重大利益的除外。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（7）根据您的要求签订合同所必需的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（8）用于维护所提供的产品与/或服务的安全稳定运行所必需的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（9）法律法规规定的其他情形。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <strong><span style=" color:black;background:white">2.</span></strong><strong><span style=" color:black;background:white">【我们如何使用您的个人信息】</span></strong>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">我们将以如下目的和方式使用您的个人信息：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）在我们业务过程中与您和其他相关人士进行沟通。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）向您寄送与我们的保单、合同以及其他相关的重要信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）改善服务品质（比方致电我们的联系电话时，对来电进行录音或监测；又如通过授权设备MAC地址一键登陆本平台）；进行市场研究和分析（包括满意度调查）。为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。将您在使用我们某项服务时的信息，用于另一项服务中向您展示个性化的内容或广告、用于用户研究分析与统计或其他服务。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（4）根据您所表明的营销偏好（如您点击、收藏、搜索、浏览、分享频次较高的信息），向您提供营销信息（包括与所选第三方合作伙伴提供的其他产品和服务有关的信息 详情点击查看）。通过使用收集的信息，我们会得以向您提供定制内容，例如向您展现或推荐相关程度更高（而非普遍推送）的搜索结果、信息流或者广告/推广信息结果。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（5）便利您参与竞赛、抽奖和类似促销活动以及管理这些活动。有些活动有附加条款和条件，其中可能包括我们如何使用和披露您的个人信息，因此，我们建议您仔细阅读这些条款和条件。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（6）用于业务运营管理； 各类客户服务；财务会计、收付款项；IT系统、数据和网站存储、业务备份；审计、检查。 我们使用收集的信息来提供并改进我们及易才关联方、合作方提供的产品和服务，并进行必要的业务运营，提供运营产品或提供服务，评估、维护和改进产品和服务的性能，开发新的产品和服务、提供客户支持。为改进我们及易才关联方、合作方的产品和服务，我们也可能会对产品使用情况进行统计和分析。同时，易才可能会与公众共享这些统计信息，以展示我们服务的整体使用趋势，但这些统计信息将不会包含您的任何身份识别信息。我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的统计类产品。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的大数据分析信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（7）解决投诉纠纷，处理数据访问或资料更正请求。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（8）为您提供安全保障。为提高您使用我们与易才关联方、合作方提供的产品和服务的安全性，我们可能使用您的信息用于身份验证、客户服务、安全防范、诈骗监测、信贷分析，以预防、发现、调查欺诈、危害安全、非法或违反与我们的协议、政策或规则的行为，以保护您、我们的其他用户、我们或易才关联方、合作方及社会公众的合法权益。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（9）遵守适用的法律法规和监管要求（包括您的居住国法律以外的法律），例如与反洗钱和反恐融资有关的法律法规和监管要求；遵守法律程序以及其他政府机构的要求。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（10）当我们要将信息用于本政策未载明的其他用途，将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（11）为了更好地提升您的投保体验，我们将会对您的个人健康数据进行筛选、分析，以便我们能够根据您的健康状况判断您与当前产品的适配性或为您推荐更合适的产品。如果您不希望使用这项服务，您可以联系<strong>4006-234-345</strong>电话取消授权，关闭根据个性化标签进行信息推送的服务。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">3.</span><span style=" color:black;background:white">【我们如何共享、转让、公开披露您的个人信息】</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">3.1 </span><span style=" color:black;background:white">共享</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">我们会以高度的勤勉义务对待您的信息。除以下情形外，未经您同意，我们不会与除易才及其关联公司外的任何公司、组织和个人分享您的信息：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）在获得您的明确同意后，我们会与其他方共享您的个人信息。我们可能会根据法律法规规定，或按政府主管部门的强制性要求或司法裁定，对外共享您的个人信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享与提供服务相关的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">目前，我们的授权合作伙伴包括以下类型：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">合作保险公司或保险中介机构： 您在投保特定保险产品时，我们需要与该产品承保的保险公司或为该产品提供保险服务的保险中介机构共享您的个人信息，才能安排其为您提供后续核保、承保、理赔或其他保险服务。具体合作保险机构公司或者保险中介机构，您可以在易才宏业保险经纪官网的信息披露平台中（具体链接为：https://www.dhjyib.com/）进行查询。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">服务平台或服务提供商。某些营销推广活动可能由我们与第三方联合举办， 只有将您在活动过程中产生的、为完成活动所必要的信息共享给第三方时，才能及时与您联系，发放奖品、提供服务。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">软硬件/系统服务提供商。 当第三方软硬件/系统产品或服务与易才的产品或服务结合为您提供服务时，经您授权，我们会向第三方软硬件/系统服务提供商提供您必要的个人信息，以便您使用服务，或用于我们分析产品和服务使用情况，来提升您的使用体验。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">广告、咨询类服务商/广告主。 未经您授权，我们不会将您的个人身份信息（指可以识别您身份的信息，通过这些信息可以联系到您或识别您的身份）与提供广告、咨询类服务商共享。但我们可能会将经处理无法识别您的身份且接收方无法复原的信息与广告或咨询类服务商或广告主共享，以帮助其在不识别您个人的前提下，提升广告有效触达率，以及分析我们的产品和服务使用情况。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">第三方验证机构： 基于个人保险实名制的要求，我们需要向合法持有您的个人信息的第三方验证机构共享您的 姓名、身份证号、身份证件和人脸图像， 并申请核验您的身份信息的真实性。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的信息、保护易才保险经纪关联公司或其他用户或公众的人身财产安全免遭侵害或与您取得联系，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息（如为便于您使用易才账号使用我们关联公司产品和/或服务，我们会向关联公司共享您必要的账户信息），必要时，我们将对你的信息做匿名化处理。如果我们改变个人信息的使用及处理目的，将再次征求您的授权同意。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（4）对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">3.2 </span><span style=" color:black;background:white">转让</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">我们不会将您的个人信息转让给任何公司、组织和个人， 但以下情形除外：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）在获得您的明确同意的情况下转让；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）在涉及合并、收购或破产清算时，如涉及个人信息转让，我们会要求新的持有您个人信息公司、组织继续受此个人信息保护政策约束，否则我们将要求该公司、组织重新向您征求授权同意。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">3.3 </span><span style=" color:black;background:white">公开披露</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">我们仅会在以下情形下，公开披露您的个人信息：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" background:white">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）获得您的明确同意；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）基于法律的披露：在法律法规、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开您的个人信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">3.4</span><span style=" color:black;background:white">共享、转让、公开披露个人信息时事先征得授权同意的例外</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">在以下情形中，共享、转让、公开披露您的个人信息 无需事先征得您的授权同意：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）与国家安全、国防安全直接相关的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）与公共安全、公共卫生、重大公共利益直接相关的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（5）您自行向社会公众公开的个人信息；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（7）根据个人信息主体要求签订和履行合同所必需的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（9）法律法规规定的其他情形。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（10）根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">4.</span><span style=" color:black;background:white">【我们如何保存和保护您的个人信息】</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">4.1.</span><span style=" color:black;background:white">保存期限</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">您在使用易才保险经纪产品及服务期间，我们将持续永久为您保存您的个人信息。如果您注销帐户或主动删除上述信息，我们将及时进行处理，但法律和监管规定要求保留的除外。一旦您选择注销您的账户，您的个人信息和相关数据将会立即在平台的前台以及后台系统中去除，以后将不可检索、访问及恢复，请您在操作之前自行备份易才账户相关的所有信息和数据。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">4.2.</span><span style=" color:black;background:white">保存地域</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">您的个人信息均储存于中华人民共和国境内。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">4.3.</span><span style=" color:black;background:white">安全措施</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。在您的浏览器与“服务”之间交换数据（如银行卡信息）时受 SSL 加密保护；我们同时对易才保险经纪旗下网站提供 https 安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（4）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（5）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以邮件、信函、电话、推送通知方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（6）同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">5.</span><span style=" color:black;background:white">【您的权利】</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">5.1.</span><span style=" color:black;background:white">您有权 访问、查询 您在我们平台上留存的个人信息，法律法规规定的例外情况除外。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">5.2</span><span style=" color:black;background:white">您发现我们处理的关于您的个人信息有错误时，您有权对错误或不完整的信息作出 更正或更新， 您可以通过我们提供的联系方式随时与我们联系，提出更正申请。我们会根据本隐私政策所列明的方式和期限响应您的请求。为保障安全，我们将在您行使更正权前对您的身份进行验证。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">5.3.</span><span style=" color:black;background:white">删除您的个人信息或注销您的账户</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">您可以向我们提出删除个人信息的请求，您可以通过我们提供的联系方式反馈随时与我们联系。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">在以下情形中，您可以向我们提出删除个人信息的请求：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）如果我们处理个人信息的行为违反法律法规；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）如果我们收集、使用您的个人信息，却未征得您的同意；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）如果我们处理个人信息的行为严重违反了与您的约定；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（4）如果您不再使用我们的产品或服务，或您注销了易才账户；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（5）如果我们终止服务及运营，或者保存期限已届满。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">若我们决定响应您的删除请求，我们还将同时尽可能通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体已获得您的独立授权。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">请您注意，当您成功注销易才账户后，我们将对您的个人信息进行删除。当您或我们协助您删除相关信息后，如因为适用的法律的限制，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到可以实现匿名化。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">5.4</span><span style=" color:black;background:white">改变您授权同意的范围或撤回您的授权</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">您可以通过易才保险经纪网APP，访问”我的-设置-通用设置”撤回消息推送，定位服务，读写照片及文件，相机，个性化推送的权限。您也可以通过注销账号的方式，撤回我们继续收集您个人信息的全部授权。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">5.5</span><span style=" color:black;background:white">注销账户</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">您可以在我们的产品中直接申请注销账户。您可以通过易才保险经纪相关APP 访问“我的-设置-账户安全-注销账户”完成账号注销，关于您注销账户的方式以及您应满足的条件。您注销账户后，我们将停止为您提供产品或服务，并根据适用法律的要求立即删除您的个人信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">5.6</span><span style=" color:black;background:white">响应您的上述请求</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息或者获取个人信息副本，或您认为易才存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以发送电子邮件至 </span><span style="font-size:11px color:black;background:white">ycbxjj@chinatalentgroup.com</span><span style=" color:black;background:white">或通过本隐私政策中的其他方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或提供您的身份证明文件，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">5.7</span><span style=" color:black;background:white">在以下情形中，按照法律法规要求，我们将无法响应您的上述请求：</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（1）与国家安全、国防安全直接相关的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（2）与公共安全、公共卫生、重大公共利益直接相关的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（3）与犯罪侦查、起诉、审判和执行判决等直接相关的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（4）我们有充分证据表明您存在主观恶意或滥用权利的（如您的请求将危害公共安全和其他人合法权益，或您的请求超出了一般技术手段和商业成本可覆盖的范围）；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（5）响应个人信息主体的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（6）涉及法律法规或监管政策的特殊规定；</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">（7）涉及商业秘密的。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">6.</span><span style=" color:black;background:white">【我们如何处理未成年人的个人信息】</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">对于经父母或监护人同意而收集的未成年人个人信息情况，我们只会在收到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">如果父母或监护人发现我们在未获其同意的情况下收集了未成年人的个人信息，请通过我们提供的联系方式联系我们，我们会设法尽快删除相关数据。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">7.</span><span style=" color:black;background:white">【本政策如何更新】</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">我们可能适时修订本政策内容。如该变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、弹窗方式通知您。我们会在本页面上发布对本个人信息保护政策所做的任何变更。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">若您不同意该变更可以停止使用易才保险经纪相关平台产品和服务，若您继续使用我们的产品和/或服务，即表示您同意受修订后的本个人信息保护政策的约束。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">8.</span><span style=" color:black;background:white">【如何联系我们】</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">如您对本政策有任何疑问、意见或建议，可通过以下方式联系我们。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white"><strong>易才信息安全组专线：4006-234-345</strong></span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">注册地址及常用办公地址：天津市河西区黑牛城道与洞庭路交口东南侧五福大厦-1-1407、-1-1408。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">一般情况下，我们将在十五日内回复，如果我们未在15日内回复的，您可以通过<strong>客服热线：4006-234-345</strong> 进行投诉。</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-align:left;line-height:24px;background:white">
    <span style=" color:black;background:white">如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：将争议提交易才所在地有管辖权的人民法院处理。</span>
</p>
<p style="line-height:24px">
    <span >&nbsp;</span>
</p>
<p>
    <br/>
</p>`;
